import { Navigate, Route, Routes, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./auth/AuthContext";
import AdminNav from "./components/AdminNav";
import AdBlockUyari from "./components/AdBlockUyari";
import Login from "./pages/Login";
import Customers from "./pages/Customers";
import CustomerDetail from "./pages/CustomerDetail";
import Accounting from "./pages/Accounting";
import Support from "./pages/Support";
import Settings from "./pages/Settings";
import AISettings from "./pages/AISettings";
import Corpus from "./pages/Corpus";
import MevzuatSorulari from "./pages/MevzuatSorulari";
import MailTracking from "./pages/MailTracking";
import MailTrackingDetail from "./pages/MailTrackingDetail";
import Ziyaretciler from "./pages/Ziyaretciler";
import ZiyaretciDetay from "./pages/ZiyaretciDetay";
import Unsubscribes from "./pages/Unsubscribes";

function Layout() {
  return (
    <div className="shell">
      <AdminNav />
      <div className="content-area">
        <main className="content">
          {/* Panel genelinde: engelleyici olcum uclarini sessizce kesiyor. */}
          <AdBlockUyari />
          <Outlet />
        </main>
      </div>
    </div>
  );
}

function RequireAuth() {
  const { token } = useAuth();
  const loc = useLocation();
  if (!token) return <Navigate to="/login" state={{ from: loc }} replace />;
  return <Layout />;
}

export default function App() {
  const { token } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={token ? <Navigate to="/customers" replace /> : <Login />} />
      <Route element={<RequireAuth />}>
        <Route path="/customers" element={<Customers />} />
        <Route path="/customers/:id" element={<CustomerDetail />} />
        <Route path="/muhasebe" element={<Accounting />} />
        <Route path="/destek" element={<Support />} />
        <Route path="/ai" element={<AISettings />} />
        <Route path="/corpus" element={<Corpus />} />
        <Route path="/mevzuat-sorulari" element={<MevzuatSorulari />} />
        {/* Eski yol yer imlerinde/geçmişte kalmış olabilir — 404 yerine yönlendir. */}
        <Route path="/cevapsiz" element={<Navigate to="/mevzuat-sorulari" replace />} />
        <Route path="/mail-takip" element={<MailTracking />} />
        <Route path="/mail-takip/:id" element={<MailTrackingDetail />} />
        <Route path="/ziyaretciler" element={<Ziyaretciler />} />
        <Route path="/ziyaretciler/:key" element={<ZiyaretciDetay />} />
        <Route path="/listeden-cikanlar" element={<Unsubscribes />} />
        <Route path="/ayarlar" element={<Settings />} />
      </Route>
      <Route path="/" element={<Navigate to="/customers" replace />} />
      <Route path="*" element={<Navigate to="/customers" replace />} />
    </Routes>
  );
}
